import RolesRepository from "./RolesRepository";
import TeamsRepository from "./TeamsRepository";
import MembersRepository from "./MembersRepository";
import OfficesRepository from "./OfficesRepository";
import CompaniesRepository from "./CompaniesRepository";
import DashboardsRepository from "./DashboardsRepository";
import DashboardsExecutiveRepository from "./DashboardRepository";

export const Api = {
  roles: RolesRepository,
  teams: TeamsRepository,
  members: MembersRepository,
  offices: OfficesRepository,
  companies: CompaniesRepository,
  dashboards: DashboardsRepository,
  executiveDashboard: DashboardsExecutiveRepository,
};
